//        WEB LOCAL STORAGE VARIABLES
export const CONST_LOCALSTORAGE_DOCUMENTID = "doId";
export const CONST_LOCALSTORAGE_ITEMID = "itId";
export const CONST_LOCALSTORAGE_CONTACTID = "ctId";

export const CONST_LOCALSTORAGE_CONTACTISCUSTOM = "ctCu";
export const CONST_LOCALSTORAGE_ITEMISCUSTOM = "itCu";

